
function ScoreHeader() {
  return (
    <thead>
      <tr>
        <th scope='col'>You</th>
        <th scope='col'>Bot</th>
      </tr>
    </thead>
  );
}

function ScoreCell({ score, color }) {
  return (
    <td>
      <h4>
        <span className={`badge text-bg-${color}`}>
          {score}
        </span>
      </h4>
    </td>
  );
}

function getColors(a, b) {
  if (a > b)
    return ['primary', 'warning'];
  else if (a < b)
    return ['warning', 'primary'];
  else
    return ['warning', 'warning'];
}

function Score({ player, bot }) {
  let [p_color, b_color] = getColors(player, bot);
  return (
    <div className='card col-3'>
      <h4 className='card-title py-2 border-bottom text-center'>Score</h4>
      <div className='card-body'>
        <table className='table text-center table-borderless'>
          <ScoreHeader />
          <tbody>
            <tr>
              <ScoreCell score={player} color={p_color} />
              <ScoreCell score={bot} color={b_color} />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Score;
